import React, { createContext, useContext, useState, useCallback } from "react";

const QuoteModalContext = createContext(null);

export const QuoteModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open  = useCallback(() => setIsOpen(true),  []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <QuoteModalContext.Provider value={{ isOpen, open, close }}>
      {children}
    </QuoteModalContext.Provider>
  );
};

export const useQuoteModal = () => useContext(QuoteModalContext);
